import API, { ensurePrefixed } from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import getFormattedValues, { formatReceived } from 'utils/formatValues';
import { padronesEnum } from 'views/Tramites/GPM/enums';

export const baseURI = '/empresas/estacionamientos/';
/**
 * GET Estacionamientos
 * @param {Object} params
 * @returns {Promise<Array<Object>>}
 */
export const getEstacionamientos = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    const output = { ...response.data, results: formatReceived(response.data.results) };
    return output;
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET Estacionamiento
 * @param {number} id
 * @returns {Promise<Object>}
 */
export const getEstacionamiento = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Estacionamiento
  * @param {Object} values
 * @returns {Promise<Object>}
 */
export const postEstacionamiento = async (_values, accion = 'ESTACIONAMIENTO') => {
  try {
    const values = getFormattedValues(_values, { clean: false });
    const accionInf = ensurePrefixed('CREAR_', accion);
    const response = await API.post(baseURI, values, {
      accionInf,
      idPadron: padronesEnum.ESTACIONAMIENTO,
      clave: values.clave,
    });
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Estacionamiento
 * @param {number} id
 * @param {Object} values
 * @returns {Promise<Object>}
 */
export const patchEstacionamiento = async (id, _values, accion = 'ESTACIONAMIENTO') => {
  try {
    const values = getFormattedValues(_values, { clean: false });
    const accionInf = ensurePrefixed('EDITAR_', accion);
    const response = await API.patch(`${baseURI}${id}`, values, {
      accionInf,
      idPadron: padronesEnum.ESTACIONAMIENTO,
      clave: values.clave,
    });
    onSuccess(response, 'Editado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Estacionamiento
 * @param {number} id
 * @returns {Promise<Object>}
 */
export const deleteEstacionamiento = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * GET Arrendamiento para la caja
 * @param {object} params
 * @returns {Promise<Array<Object>>}
 */
export const getEstacionamientoCaja = async (params = null) => {
  try {
    const response = await API.get('/empresas/estacionamiento-caja/', { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};
